import React from "react";
import "../css/cursor.css";

const Cursor = () => {
  // let getProduct: string = "samsung";
  return <div id="cursor"></div>;
};

export default Cursor;
